<template>
    <NotificationBell v-if="bellThemes.includes(theme)" class="ui-header-button" />
    <NotificationButton v-else />
</template>

<script setup lang="ts">
/**
 * Two visual variants exist historically: hvp-family themes use the
 * self-contained bell dropdown, the rest the Float popover button.
 * Theme is fixed per bundle (VITE_THEME_ADMIN), so the branch is
 * compile-time constant. Temporary bridge until the dropdowns unify.
 *
 * (Keep <template> comment-free — dev builds preserve template comments and a
 * root-level one makes the component a fragment; see UiHeaderButton.vue.)
 */
import NotificationBell from '@src/Notifications/Pages/NotificationBell.vue';
import NotificationButton from '@src/Notifications/Pages/NotificationButton.vue';

const theme = import.meta.env.VITE_THEME_ADMIN as string;
const bellThemes = ['hvp', 'polygon', 'skolka'];
</script>
